export const TRACK_EVENT_ENDPOINT = "/track-event";
